import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/proposition-bets-widget.module.scss";
import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {Link} from "../../../../core/components/link/link";

export const PropositionBetsWidgetSectionTitle = observer(({controller, currentRows, section}) => {
  const {state, config} = controller;
  const {currentLinkModel, sportTypeId} = state;
  const {source} = config;
  const {competitor} = section;

  const shouldRenderTitle = currentRows?.length > 0
  const linkProps = {
    model: competitor?.linkModel,
    className: styles.section_title,
    onClick: () => controller.action(ACTION_TYPES.entityClick, {
      entityId: competitor.id,
      entityName: competitor.nameForURL,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[competitor.objectType],
      currentLinkModel,
      sportTypeId,
      source
    })
  }

  const competitorLogoProps = {
    className: classNames(styles.section_competitor_logo),
    entity: competitor,
    width: 24,
    height: 24
  }

  return (
    shouldRenderTitle ? <div className={classNames(styles.section_title_container)}>
      <Link {...linkProps}>
        <EntityLogo {...competitorLogoProps}/>
        {competitor?.name}
      </Link>
    </div> : null
  )
});
